import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  slug: string;
  title: string;
  coverImage: string;
  rating: number;
  latestChapter: number;
  status: string;
  variant?: 'default' | 'horizontal';
}

export default function ComicCard({ slug, title, coverImage, rating, latestChapter, status, variant = 'default' }: ComicCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link to={`/article/${slug}`} className="flex items-center gap-3 p-3 rounded-xl bg-background-50 hover:bg-background-100 transition-colors cursor-pointer group">
        <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0">
          <img src={coverImage} alt={title} title={`${title} - 韩漫漫画网`} className="w-full h-full object-cover object-top" loading="lazy" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">{title}</h4>
          <p className="text-xs text-foreground-500 mt-0.5">第 {latestChapter} 话</p>
        </div>
        <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{rating}</span>
      </Link>
    );
  }

  return (
    <Link to={`/article/${slug}`} className="block group cursor-pointer">
      <div className="relative rounded-xl overflow-hidden bg-background-200 aspect-[3/4]">
        <img src={coverImage} alt={title} title={`${title} - 韩漫漫画网`} className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105" loading="lazy" />
        {status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
            连载
          </span>
        )}
        {status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-foreground-600 text-background-50 text-xs font-medium">
            完结
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-900/80 to-transparent p-3 pt-8">
          <div className="flex items-center justify-between">
            <span className="text-background-50 text-xs font-medium">第 {latestChapter} 话</span>
            <span className="text-primary-300 text-xs font-bold">{rating}</span>
          </div>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">{title}</h3>
    </Link>
  );
}